import { render, staticRenderFns } from "./AuditTrail.vue?vue&type=template&id=33786bae&scoped=true&"
import script from "./AuditTrail.vue?vue&type=script&lang=js&"
export * from "./AuditTrail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33786bae",
  null
  
)

export default component.exports